export const API_BASE_URL = "https://arbitrage-services-graphs-v2.org/api"
export const SOCKET_URL = "wss://arbitrage-services-graphs-v2.org"
